import type {SenseAction} from 'src/action-creators/types';

import {RECEIVE_ALLOWED_MEDIA_EXTENSIONS} from 'src/action-creators/chat/file-upload';


export type State = {
  extensions: string[];
};

const initialState = {
  extensions: [],
} as const;

export default function reduce(
  // @ts-expect-error - TS2322 - Type '{ readonly extensions: readonly []; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: SenseAction,
): State {
  switch (action.type) {
    case RECEIVE_ALLOWED_MEDIA_EXTENSIONS: {
      return {
        ...state,
        extensions: action.payload,
      };
    }

    default:
      // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
      return state;
  }
}
